import { css } from 'styled-components'
import { borderRadius, ThemedComponentProps, Typography } from '~theme'
import { iconOffsetList, makeTemplates, paddingList, sizeList } from './Button.templates'
import { ShapeType, SizeType, StyledButtonProps, ViewType } from './Button.types'

export const getView = (view: ViewType) => (props: ThemedComponentProps) => makeTemplates(props)[view]

export const getSize = (size: SizeType) => sizeList[size]

export const getPadding = (size: SizeType) => paddingList[size]

export const getTypography = (size: SizeType) => {
  switch (size) {
    case 'extra-small':
      return Typography.labelSmall
    case 'small':
      return Typography.labelMedium
    default:
      return Typography.labelLarge
  }
}

export const getIconOffset = (size: SizeType) => iconOffsetList[size]

export const getBorderRadius = (shape: ShapeType) => {
  switch (shape) {
    case 'circle':
      return '50%'

    default:
      return borderRadius
  }
}

export const getShape = (shape: ShapeType, size: SizeType) => {
  switch (shape) {
    case 'circle':
    case 'square':
      return css`
        width: ${getSize(size)};
        padding: 0;
      `

    default:
      return null
  }
}

export const getShapeIconSize = (shape: ShapeType) => {
  switch (shape) {
    case 'circle':
    case 'square':
      return css`
        max-width: 100%;
        max-height: 100%;
      `

    default:
      return null
  }
}

export const getCursor = (props: StyledButtonProps) => {
  if (props.isDisabled) {
    return 'not-allowed'
  }

  if (props.isSuccess) {
    return 'default'
  }

  if (props.isLoading) {
    return 'wait'
  }

  return null
}
